export const ACL_ENGINE_EDGE_TYPES = [
  'GenericAll',
  'GenericWrite',
  'WriteOwner',
  'WriteDacl',
  'Owns',
  'AllExtendedRights',
  'WriteSPN',
  'AddMember',
  'AddSelf',
  'ForceChangePassword',
] as const;

export type AclEngineEdgeType = (typeof ACL_ENGINE_EDGE_TYPES)[number];

export const ACL_WRITE_EDGE_TYPES = ACL_ENGINE_EDGE_TYPES;

export type AclWriteEdgeType = (typeof ACL_WRITE_EDGE_TYPES)[number];

const aclEngineEdgeTypes = new Set<string>(ACL_ENGINE_EDGE_TYPES);
const aclWriteEdgeTypes = new Set<string>(ACL_WRITE_EDGE_TYPES);

export const isAclEngineEdgeType = (
  relationshipType: string,
): relationshipType is AclEngineEdgeType =>
  aclEngineEdgeTypes.has(relationshipType);

export const isAclWriteEdgeType = (
  relationshipType: string,
): relationshipType is AclWriteEdgeType =>
  aclWriteEdgeTypes.has(relationshipType);
